import React from 'react';
import { CHART_STRINGS } from '../helpers/graphConstants';
import { ReactComponent as TtdLegendArrow } from '../../../../../assets/Images/DynamicChartAssets/TTDLegendArrow.svg';

const CustomLegend = () => (
  <ul className="chart-legend">
    <li>
      <span className="legend-icon line-solid" />
      {CHART_STRINGS.LEGEND_INTERVENTION_LINE}
    </li>
    <li>
      <span className="legend-icon line-dashed" />
      {CHART_STRINGS.LEGEND_NO_INTERVENTION_LINE}
    </li>
    <li>
      <TtdLegendArrow className="legend-icon" />
      {CHART_STRINGS.LEGEND_PROLONG_DIALYSIS_LINE}
    </li>
  </ul>
);

export default CustomLegend;
